module.exports = __webpack_public_path__ + "static/media/dna_itovi_450x450.48c1eef3.png";